import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'company-user-phone',
  templateUrl: './company-user-phone.component.html',
})
export class CompanyUserPhoneComponent {
  @Input() public formGroup: UntypedFormGroup;

  public errorsPhone: { [name: string]: string } = {
    maxlength: 'FORM_ERROR.MAX_LENGTH',
    validatePhoneNumber: 'FORM_ERROR.PHONE_NUMBER',
    required: 'FORM_ERROR.REQUIRED',
  };

  constructor() {}
}
